export const AI_CHAT_USE = 'ai-chat.use';
export const AI_CHAT_MANAGE = 'ai-chat.manage';

const SUPER_ROLES = ['admin'];

function readRolesArray() {
    try {
        const raw = localStorage.getItem('roles');
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
        return [];
    }
}

export function hasSuperRole() {
    const roles = readRolesArray();
    return roles.some(r => {
        const name = r && typeof r.name === 'string' ? r.name.toLowerCase() : '';
        return SUPER_ROLES.indexOf(name) !== -1;
    });
}

function readFromLocalStorageRoles() {
    try {
        const raw = localStorage.getItem('roles');
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return [];
        const out = [];
        parsed.forEach(role => {
            const perms = role && Array.isArray(role.permissions) ? role.permissions : [];
            perms.forEach(p => {
                if (typeof p === 'string') out.push(p);
                else if (p && p.name) out.push(p.name);
            });
        });
        return out;
    } catch (e) {
        return [];
    }
}

function decodeJwt(token) {
    try {
        const parts = token.split('.');
        if (parts.length < 2) return null;
        const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        return JSON.parse(decodeURIComponent(escape(atob(payload))));
    } catch (e) {
        try {
            return JSON.parse(atob(token.split('.')[1]));
        } catch (_) {
            return null;
        }
    }
}

function readFromJwt() {
    const token = localStorage.getItem('token');
    if (!token) return [];
    const payload = decodeJwt(token);
    if (!payload) return [];
    const out = [];
    if (Array.isArray(payload.permissions)) {
        payload.permissions.forEach(p => {
            if (typeof p === 'string') out.push(p);
            else if (p && p.name) out.push(p.name);
        });
    }
    if (Array.isArray(payload.scopes)) {
        payload.scopes.forEach(s => { if (typeof s === 'string') out.push(s); });
    }
    if (Array.isArray(payload.roles)) {
        payload.roles.forEach(r => {
            if (r && Array.isArray(r.permissions)) {
                r.permissions.forEach(p => {
                    if (typeof p === 'string') out.push(p);
                    else if (p && p.name) out.push(p.name);
                });
            }
        });
    }
    return out;
}

function getAllPermissions() {
    const fromStorage = readFromLocalStorageRoles();
    if (fromStorage.length) return { source: 'storage', list: fromStorage };
    const fromJwt = readFromJwt();
    if (fromJwt.length) return { source: 'jwt', list: fromJwt };
    return { source: 'unknown', list: [] };
}

export function hasPermission(name) {
    if (hasSuperRole()) return true;
    const { list } = getAllPermissions();
    return list.indexOf(name) !== -1;
}

export function permissionsKnown() {
    return getAllPermissions().source !== 'unknown';
}

export function canUseAiChat() {
    return hasPermission(AI_CHAT_USE);
}

export function canManageAiChat() {
    return hasPermission(AI_CHAT_MANAGE);
}
